import { z } from "zod";

export const ResolveTbaBookRequestSchema = z.object({
    amazonUrl: z.string().url().optional(),
    author: z.string().min(1),
    bookId: z.string().min(1),
    coverUrl: z.string().url().optional(),
    description: z.string().optional(),
    isbn: z.string().optional(),
    title: z.string().min(1),
});

export type ResolveTbaBookRequest = z.infer<typeof ResolveTbaBookRequestSchema>;

export const ResolveTbaBookResponseSchema = z.object({
    bookId: z.string(),
    success: z.literal(true),
});

export type ResolveTbaBookResponse = z.infer<typeof ResolveTbaBookResponseSchema>;
